// Базовый словарь: его тип (`as const`) — источник ключей и {{переменных}} для t(),
// остальные локали повторяют форму через LocaleSchema. Плюральные ключи — по CLDR
// (`_one/_few/_many/_other`), выбор формы — i18next по `count`.
export const ru = {
  common: {
    cancel: 'отмена',
    delete: 'удалить',
    deleteLabel: 'Удалить',
    close: 'закрыть',
    closeLabel: 'Закрыть',
    save: 'сохранить',
    saveSubmit: '[↵] сохранить',
    revoke: 'отозвать',
    loading: 'загрузка...',
    loadingLabel: 'загрузка',
    copied: '✓ скопировано',
    copyUrl: 'копировать URL',
    userName: 'имя пользователя',
  },

  locale: {
    switchTo: 'Сменить язык интерфейса на {{language}}',
  },

  nav: {
    downloads: 'загрузки',
    library: 'библиотека',
    subscriptions: 'подписки',
    feed: 'фид',
    tokens: 'токены',
    cookies: 'cookies',
    keys: 'ключи',
    mobile: 'Мобильная навигация',
    admin: 'Администрирование',
    logout: 'Выйти',
  },

  auth: {
    login: {
      title: 'войти passkey-ом',
      description:
        'Нажми «войти» и выбери passkey, привязанный к этому аккаунту. Никаких паролей — только Face ID, Touch ID или аппаратный ключ.',
      submit: '[↵] войти',
      registerLink: 'нет аккаунта? <b>зарегистрироваться по инвайту →</b>',
      recoveryLink: 'потерял passkey — <b>восстановить доступ</b>',
    },
    register: {
      title: 'зарегистрироваться',
      description:
        'Введи имя пользователя и инвайт-токен. После этого браузер попросит зарегистрировать passkey — Face ID, Touch ID или аппаратный ключ.',
      inviteToken: 'инвайт-токен',
      invitePlaceholder: 'один из CLI-инвайтов',
      submit: '[↵] создать аккаунт',
      loginLink: 'уже зарегистрирован? <b>войти →</b>',
    },
    recovery: {
      title: 'восстановить доступ',
      description:
        'Введи имя пользователя и один из recovery-кодов. После — браузер попросит зарегистрировать новый passkey. Старые passkey НЕ удалятся автоматически — отзови их в «Ключи».',
      code: 'recovery-код',
      codePlaceholder: 'один из 10 кодов',
      submit: '[↵] восстановить и привязать passkey',
      backLink: '← <b>вернуться к логину</b>',
    },
    codes: {
      title: 'сохрани эти коды',
      description:
        'Каждый код — одноразовый. Если потеряешь passkey, без них доступ к аккаунту не вернуть. <b>эти коды больше никогда не будут показаны.</b>',
      copy: 'копировать',
      download: 'скачать .txt',
      acknowledge: 'я сохранил коды восстановления',
      submit: '[↵] продолжить',
    },
  },

  notFound: {
    title: 'страница не найдена',
    description: 'URL, по которому ты пришёл, не существует или больше не доступен.',
    home: '[↵] на главную',
  },

  install: {
    title: 'Установить podpipe',
    description:
      'Добавьте podpipe на главный экран — открывается как приложение, без адресной строки.',
    safariOnly: 'Установка доступна в браузере Safari.',
    install: 'Установить',
    iosShare: 'Нажмите «Поделиться» в панели Safari',
    iosAddToHome: 'Выберите «На экран „Домой“» и подтвердите',
    androidMenu: 'Откройте меню браузера (⋮)',
    androidInstall: 'Выберите «Установить приложение»',
  },

  combobox: {
    showList: 'Показать список',
    empty: 'нет совпадений',
  },

  dashboard: {
    wsConnected: 'система готова · ws подключён',
    wsDisconnected: 'ws отключён · polling каждые 5с',
    title: 'превращай ссылки<br/>в <accent>персональный</accent> подкаст',
    description:
      '// вставь URL — yt-dlp скачает, ffmpeg перекодирует, RSS обновится. твой подкаст-клиент увидит новый эпизод через минуту.',
    pasteLabel: 'Вставить ссылку из буфера',
    pasteTitle: 'Вставить ссылку из буфера (shift+↵ — сразу probe)',
    pasteHint: '// <kbd>⇧</kbd>+<kbd>↵</kbd> — вставить ссылку из буфера и сразу запустить probe',
    downloadStarted: 'Загрузка запущена',
    quotaExceeded: 'Квота исчерпана — удалите эпизоды',
    clipboardNoLink: 'В буфере нет ссылки',
    clipboardDenied: 'Нет доступа к буферу обмена',
    jobDeleted: 'Задача удалена',
    noJobs: '// тишина — нет задач',
    deleteTitle: 'Удалить задачу?',
    deleteText:
      'Карточка задачи будет убрана из списка. Уже созданный эпизод (если есть) останется в библиотеке.',
    untitled: 'без названия',
    handlerNode: '// handler-нода',
    noNodes: '// нет доступных нод',
    hideFormats: '// скрыть список форматов',
    showFormats: '// выбрать форматы вручную ({{total}})',
    formatsSelected: '{{selected}} выбрано',
    startDownload: '[↵] начать загрузку',
    formatsHint:
      '// выбери видео-формат + audio-формат или один комбинированный. Если ничего не выбрано — yt-dlp подберёт сам по пресету.',
  },

  library: {
    episodeCount_one: '{{count}} эпизод',
    episodeCount_few: '{{count}} эпизода',
    episodeCount_many: '{{count}} эпизодов',
    episodeCount_other: '{{count}} эпизода',
    loading: 'загружаю эпизоды',
    empty: '// эпизодов пока нет — иди на главную и добавь URL',
    deleted: 'Эпизод удалён',
    deleteTitle: 'Удалить эпизод?',
    deleteText:
      'Файл удалится из S3 и из БД. Подкаст-клиент, у которого эпизод уже скачан, продолжит его проигрывать локально — но при обновлении фида увидит, что эпизод пропал. Это необратимо.',
    listened: 'прослушано',
  },

  subscriptions: {
    title: 'подписки',
    description:
      'Подпишись на канал — сервис сам раз в ~15 минут проверяет его и ставит новые ролики в загрузку выбранным пресетом. Готовые эпизоды появятся в фиде и в списке задач на главной.',
    subscribe: '+ подписаться',
    created: 'Подписка создана',
    updated: 'Подписка обновлена',
    removed: 'Отписка выполнена',
    loading: 'загружаю подписки',
    empty: '// подписок нет — добавь канал YouTube · VK · Rutube · Twitch',
    preset: 'пресет: {{preset}}',
    active: 'активна',
    paused: 'на паузе',
    checked: 'проверена {{when}}',
    neverChecked: 'ещё не проверялась',
    editPreset: 'пресет',
    unsubscribe: 'отписаться',
    createTitle: 'новая подписка',
    channelUrl: 'ссылка на канал',
    channelHint: 'Поддерживаются YouTube, VK, Rutube, Twitch.',
    downloadPreset: '// пресет загрузки',
    subscribeSubmit: '[↵] подписаться',
    editTitle: 'изменить подписку',
    activeToggle: 'подписка активна — проверять канал и качать новые ролики',
    unsubscribeTitle: 'отписаться?',
    unsubscribeText:
      'Канал перестанет проверяться, новые ролики качаться не будут. Уже созданные эпизоды останутся в библиотеке.',
  },

  settings: {
    feed: {
      title: 'настройки фида',
      description: 'Как фид выглядит в подкаст-клиенте — заголовок, обложка, категория.',
      saved: 'Сохранено',
      ownerEmailHint:
        'Контактный email владельца (itunes:owner). Нужен для публикации в каталоге Apple Podcasts; для личной подписки по ссылке — необязателен.',
      languageHint: 'Введи код локали или выбери из списка. Свой код допустим.',
      categoryHint: 'Категория, как её увидят в Apple Podcasts.',
    },
    tokens: {
      title: 'feed-токены',
      description:
        'Каждый токен — отдельный read-only URL для подкаст-клиента. Отзыв немедленно ломает подписку, использовавшую токен.',
      create: '+ создать токен',
      revoked: 'Токен отозван',
      loading: 'загружаю токены',
      empty: '// токенов нет — создай первый, подключи подкаст-клиент',
      createdAt: 'создан {{when}}',
      lastUsed: 'последнее обращение: {{when}}',
      neverUsed: 'не использовался',
      createTitle: 'новый feed-токен',
      name: 'имя',
      nameHint: 'Чтобы помнить какой клиент использует этот URL — удобно при отзыве.',
      createSubmit: '[↵] создать',
      createdTitle: 'токен создан — сохрани URL',
      revokeTitle: 'отозвать токен?',
      revokeText:
        'Подписки на feed-URL с этим токеном перестанут работать немедленно. Это необратимо.',
      qrReady:
        '<accent>{{name}}</accent> готов. <warn>Токен показывается только сейчас — после закрытия диалога не вернуть.</warn>',
      addToApplePodcasts: 'Добавить в Apple Podcasts',
      appleHint: 'iPhone / Mac — наведи камеру на QR или нажми кнопку',
      otherClientsHint: 'Android · Overcast · Pocket Casts · Castro — вставь этот URL в клиент',
      done: 'готово',
    },
    cookies: {
      title: 'cookies',
      description:
        'Для приватного/возрастного контента за логином (YouTube и др.). Загрузите Netscape cookies.txt для домена — сервис сам подложит его в yt-dlp по совпадению домена со ссылкой.',
      helpLabel: 'как получить cookies',
      add: '+ добавить',
      saved: 'cookies сохранены',
      removed: 'cookies удалены',
      loading: 'загружаю cookies',
      empty: '// cookies не загружены — добавь cookies.txt для домена с логином',
      noExpiry: 'без срока (session)',
      expired: 'истекли {{when}}',
      expires: 'истекают {{when}}',
      updated: 'обновлены {{when}}',
      uploadTitle: 'добавить cookies',
      file: 'файл cookies.txt',
      domain: 'домен',
      domainHint: 'Домен второго уровня — применится ко всем поддоменам (www, m и т.д.).',
      helpPrompt: 'Не знаете, где взять файл? <help>инструкция по браузерам</help>',
      uploadSubmit: '[↵] загрузить',
      deleteTitle: 'удалить cookies?',
      deleteText: 'Скачивание контента за логином с этого домена снова потребует свежие cookies.',
      help: {
        title: 'как получить cookies.txt',
        intro:
          'Нужен файл в формате <b>Netscape cookies.txt</b> для домена с вашей авторизацией. Первая строка файла должна быть <code># Netscape HTTP Cookie File</code> — расширения пишут её автоматически.',
        noExtension: 'нет удобного расширения',
        chromeInstall:
          'Установите расширение из Chrome Web Store (экспортирует строго локально, ничего не отправляет).',
        chromeLogin: 'Залогиньтесь на нужном сайте (например youtube.com) в этом же браузере.',
        chromeOpen: 'Откройте страницу сайта и нажмите иконку расширения.',
        chromeExport: 'Нажмите Export → сохранится файл cookies.txt.',
        firefoxInstall: 'Установите дополнение из addons.mozilla.org.',
        firefoxLogin: 'Залогиньтесь на нужном сайте в Firefox.',
        firefoxOpen: 'Откройте страницу сайта, нажмите иконку дополнения.',
        firefoxExport: 'Выберите Current Site → Download / Export.',
        safariNone: 'Готового расширения для экспорта cookies.txt нет.',
        safariWorkaround: 'Проще всего залогиниться в Chrome или Firefox и экспортировать оттуда.',
        safariFormat:
          'Полученный cookies.txt одинаково подходит — формат Netscape общий для всех браузеров.',
        outro:
          'Cookies истекают: если скачивание перестало проходить с ошибкой авторизации — экспортируйте и загрузите свежий файл (повторная загрузка того же домена заменит старый).',
      },
    },
    security: {
      title: 'passkey и безопасность',
      description:
        'Список passkey, привязанных к аккаунту. Минимум один должен остаться — иначе вход возможен только через recovery-код.',
      add: '+ добавить passkey',
      added: 'Ключ добавлен',
      removed: 'Ключ удалён',
      loading: 'загружаю ключи',
      addedAt: 'добавлен {{when}}',
      lastUsed: 'использовался {{when}}',
      neverUsed: 'ни разу не использовался',
      keepLast: 'Сначала добавь резервный ключ',
      addTitle: 'новый passkey',
      keyName: 'имя ключа',
      keyNameHint: 'Чтобы потом не путаться — какое устройство привязано.',
      addSubmit: '[↵] подтвердить ключом',
      deleteTitle: 'удалить passkey?',
      deleteText: 'После удаления войти через этот ключ будет невозможно. Действие необратимо.',
    },
  },

  admin: {
    users: {
      createInvite: '+ создать инвайт',
      search: 'поиск по имени…',
      loading: 'загружаю участников',
      member: 'участник',
      status: 'статус',
      date: 'дата',
      empty: 'нет участников',
      pagination: 'стр. {{page}} / {{pages}} · всего {{total}}',
      prev: '← назад',
      next: 'вперёд →',
      inviteTitle: 'новый инвайт',
      grantAdmin: 'выдать роль администратора',
      create: 'создать',
      inviteCreated: 'инвайт создан',
      tokenOnce: 'Токен показывается только один раз — скопируй сейчас.',
      copyToken: 'скопировать токен',
      copyLink: 'скопировать ссылку',
      inviteUser: 'Пользователь: <b>{{name}}</b>',
      quotaTitle: 'изменить квоту',
      quotaUser: 'участник: <b>{{name}}</b>',
      quotaUsage: 'занято {{used}} · текущая квота {{quota}}',
      newQuota: 'новая квота',
      unitGiB: 'ГиБ',
      unitMiB: 'МиБ',
      quotaZeroHint: '0 = пользователь не сможет ничего скачивать.',
      quotaUpdated: 'Квота обновлена',
      quotaRequired: 'Введите значение',
      quotaNotNumber: 'Должно быть числом',
      quotaNegative: 'Не может быть отрицательным',
      quotaTooLarge: 'Слишком большое значение',
      invited: 'приглашён',
      expires: 'истекает {{when}}',
      noQuota: 'квота не задана',
      user: 'пользователь',
      quota: 'квота',
      unban: 'разблокировать',
      ban: 'заблокировать',
      revokeAdmin: 'снять права',
      grantAdminShort: 'сделать admin',
    },
    library: {
      back: '← пользователи',
      title: 'библиотека: <accent>{{name}}</accent>',
      episodes: 'эпизоды',
      downloads: 'загрузки',
      loadingEpisodes: 'загружаю эпизоды',
      loadingDownloads: 'загружаю загрузки',
      noEpisodes: 'У пользователя нет эпизодов',
      noDownloads: 'У пользователя нет загрузок',
      episodeTitle: 'название',
      date: 'дата',
      size: 'размер',
      job: 'задача',
      status: 'статус',
      progress: 'прогресс',
      createdAt: 'создана',
      deleteTitle: 'Удалить эпизод?',
      deleteText: 'Файл удалится из S3 и из БД. Это необратимо.',
      jobStatus: {
        queued: 'в очереди',
        downloading: 'скачивание',
        transcoding: 'перекодирование',
        fetching: 'получение',
        uploading: 'загрузка',
        done: 'готово',
        error: 'ошибка',
      },
    },
    roles: {
      title: 'Управление <accent>ролями</accent>',
      description: 'Назначение и снятие роли администратора.',
      notice:
        'Изменение роли вступает в силу только после получения нового access-токена — при следующем обновлении сессии (автоматически) или повторном входе.',
      userId: 'ID пользователя',
      userIdHint: 'UUID пользователя из базы данных.',
      grant: 'назначить администратором',
      revoke: 'снять роль',
      registered: 'зарегистрирован {{when}}',
      userNotFound: 'Пользователь не найден',
    },
  },

  player: {
    label: 'Плеер',
    collapse: 'Свернуть',
    expand: 'Развернуть плеер',
    close: 'Закрыть плеер',
    rate: 'Скорость {{rate}}',
    rateTitle: 'Скорость воспроизведения',
    autoplay: 'Автоплей следующего эпизода',
    autoplayShort: 'автоплей',
    source: 'источник →',
    urlCopied: 'URL скопирован',
    urlCopyFailed: 'Не удалось скопировать URL',
    h265Note:
      '// H.265 поддерживается в Safari полностью, в Chromium — частично. Если плеер пишет ошибку — открой эпизод в подкаст-клиенте.',
    episodeDeleted: 'Эпизод удалён',
    videoFailed: 'Не удалось воспроизвести видео — H.265 поддерживается не во всех браузерах',
    episodeFailed: 'Не удалось воспроизвести эпизод',
    continuedElsewhere: 'Воспроизведение продолжено на другом устройстве',
  },

  errors: {
    generic: 'Что-то пошло не так',
    httpStatus: 'Ошибка {{status}}',
    noRefreshToken: 'Нет refresh-токена',
    sessionExpired: 'Сессия истекла',
    // По коду ErrorCode. В ru показываются, только если сервер не прислал detail.
    NOT_FOUND: 'Ресурс не найден',
    FORBIDDEN: 'Недостаточно прав доступа',
    INTERNAL: 'Внутренняя ошибка сервера',
    VALIDATION: 'Некорректные данные запроса',
    LAST_ADMIN: 'Нельзя снять роль у последнего администратора',
    USER_BANNED: 'Ваш аккаунт заблокирован',
    REQUIRED_TOKEN: 'Требуется авторизация',
    INVALID_TOKEN: 'Сессия истекла — войдите снова',
    WRONG_TOKEN_TYPE: 'Неверный тип токена',
    TOKEN_REUSE: 'Сессия отозвана — войдите снова',
    INVALID_CREDENTIAL: 'Этот passkey не привязан к аккаунту',
    INVALID_INVITE: 'Инвайт-токен невалиден или истёк',
    INVALID_RECOVERY_CODE: 'Recovery-код невалиден',
    WEBAUTHN_VERIFICATION: 'Не удалось проверить ключ — попробуйте снова',
    INVALID_FEED_TOKEN: 'Feed-токен невалиден или отозван',
    FEED_TOKEN_NOT_FOUND: 'Feed-токен не найден',
    EPISODE_NOT_FOUND: 'Эпизод не найден',
    JOB_NOT_FOUND: 'Задача не найдена',
    JOB_NOT_DELETABLE: 'Задачу нельзя удалить — она ещё не завершена',
    PROBE_FAILED: 'yt-dlp не смог прочитать ресурс — проверьте URL',
    DOWNLOAD_FAILED: 'Загрузка не удалась — повторите позже',
    UNSUPPORTED_SOURCE: 'Источник не поддерживается',
    INVALID_DOWNLOAD_REQUEST: 'Невалидные параметры загрузки',
    SUBSCRIPTION_NOT_FOUND: 'Подписка не найдена',
    SUBSCRIPTION_ALREADY_EXISTS: 'Вы уже подписаны на этот канал',
    NODES_UNAVAILABLE: 'Нет доступных handler-нод — попробуйте позже',
    COOKIE_NOT_FOUND: 'Cookies не найдены',
    INVALID_COOKIE_FILE: 'Файл не похож на Netscape cookies.txt',
    COOKIE_FILE_TOO_LARGE: 'Файл cookies слишком большой',
    COOKIE_LIMIT_EXCEEDED: 'Достигнут лимит сохранённых cookies — удалите ненужные',
    QUOTA_EXCEEDED: 'Квота исчерпана — удалите эпизоды или поднимите лимит',
  },
} as const
